import { App } from "../../app/App";
import { ClassFlag } from "../../dom-tools/ClassFlag";
import { ElementAttribute } from "../../dom-tools/ElementAttribute";
import { ElementType } from "../../dom-tools/ElementType";
import { OnChange, OnClick } from "../../dom-tools/EventListeners";
import { Insight } from "../../dom-tools/Insight";
import { Filters } from "./Filters";
import { Filter } from "./filters/Filter";
import { Sorters } from "./Sorters";
import { Sorter } from "./sorters/Sorter";


export class FilterAndSort
{
  static readonly type  = new ElementType( "filter--and--sort" );
  static readonly selector = new ElementAttribute( "selector" );     
  static readonly combinedGroup    = new ElementAttribute( "combined-group" );

  static readonly apply = new ClassFlag( "apply" );

  static applyOnDocument()
  {
    FilterAndSort.type.forAllInDoc( e => this.applyOnElement( e ) );
  }

  static applyOnElement( element:Element )
  {
    let applyButton = FilterAndSort.apply.query( element );

    let applyFiltersAndSort = ()=>
    {
      let elements = Filters.filterElements( element );
      Sorters.sortElements( element, elements );

      App.updateAll();
    }

    if ( applyButton )
    {
      OnClick.add( applyButton as HTMLElement, ev => applyFiltersAndSort() );
    }

    let filterSettings = Filter.setting.queryAll( element );

    let filterSelectors = new Set<Element>();

    filterSettings.forEach(
      ( fs )=>
      {
        let inputs = ElementType.input.queryAll( fs );

        inputs.forEach( i => OnChange.add( i, applyFiltersAndSort ) );


        if ( ElementType.option.is( fs ) )
        {
          filterSelectors.add( fs.parentElement );
        }
      }
    )   

    filterSelectors.forEach( fs => OnChange.add( fs as HTMLElement, applyFiltersAndSort ) );
    
    let sorterSettings = Sorter.setting.queryAll( element );

    sorterSettings.forEach(
      ( fs )=>
      {
        let inputs = ElementType.input.queryAll( fs );
        inputs.forEach( i => OnChange.add( i, applyFiltersAndSort ) );

        let selects = ElementType.select.queryAll( fs );
        selects.forEach( i => OnChange.add( i, applyFiltersAndSort ) );
      }
    )  

    applyFiltersAndSort();
  }

}
